import { Screen, useNavigate } from "flemo";
import { BrainIcon } from "lucide-react";

import { AuthGuard } from "@/components/AuthGuard";
import { EmptyState } from "@/components/EmptyState";
import { Button } from "@/components/ui/button";

import { ReviewQuizView } from "./_components/ReviewQuizView";
import { ReviewResultView } from "./_components/ReviewResultView";
import { ReviewSkeleton } from "./_components/ReviewSkeleton";
import { useSmartReview } from "./_hooks/useSmartReview";

export function SmartReviewPage() {
  const { replace } = useNavigate();
  const review = useSmartReview();

  return (
    <AuthGuard>
      <Screen>
        <main className="h-dvh overflow-hidden bg-primary-background pt-safe sm:bg-tertiary sm:flex sm:items-center sm:justify-center">
          {review.isLoading && <ReviewSkeleton />}

          {review.isError && (
            <div className="flex min-h-[50vh] flex-col items-center justify-center gap-6 px-5">
              <EmptyState icon={BrainIcon} title="복습을 불러오지 못했어요" description="잠시 후 다시 시도해 주세요." />
              <Button
                type="button"
                variant="default"
                className="rounded-md px-8"
                onClick={() => replace("/", {}, { transitionName: "none" })}
              >
                홈으로 돌아가기
              </Button>
            </div>
          )}

          {!review.isError && review.isEmpty && review.phase !== "result" && (
            <div className="flex flex-col items-center justify-center min-h-[50vh] gap-6 px-5">
              <EmptyState
                icon={BrainIcon}
                title="복습할 단어가 없어요"
                description="퀴즈에서 틀린 단어가 있으면 여기에 나타나요."
              />
              <Button
                type="button"
                variant="default"
                className="rounded-md px-8"
                onClick={() => replace("/", {}, { transitionName: "none" })}
              >
                홈으로 돌아가기
              </Button>
            </div>
          )}

          {!review.isLoading &&
            !review.isError &&
            !review.isEmpty &&
            review.phase === "review" &&
            review.currentQuestion && (
              <ReviewQuizView
                currentQuestion={review.currentQuestion}
                currentIndex={review.currentIndex}
                totalCount={review.questions.length}
                ratingOptions={review.ratingOptions}
                isAnswerRevealed={review.isAnswerRevealed}
                pendingQuality={review.pendingQuality}
                submissionError={review.submissionError}
                isMuted={review.isMuted}
                onRevealAnswer={review.revealAnswer}
                onSelectQuality={review.selectQuality}
                onExit={review.exitToHome}
                onToggleMute={review.toggleMute}
              />
            )}

          {!review.isError && review.phase === "result" && (
            <ReviewResultView results={review.results} onExit={review.exitToHome} onSpeak={review.speakWord} />
          )}
        </main>
      </Screen>
    </AuthGuard>
  );
}
